export default __webpack_public_path__ + "static/media/road3.42389860.png";